import Locations from './locations.json';
import 'owl.carousel';

class Infrasupport {
  constructor() {
    this.loadingOverlay = $('.loading-overlay');
  }

  static init() {
    // $('body').addClass('js');
    // this.removeLoadingOverlay();

    // Salient (annoyingly) puts their own Owl Carousel on everything
    // using the class .owl-carousel. So we have to destroy that first, and assign our own.
    const projectPhotos = $('.project-photos.owl-carousel');
    projectPhotos.trigger('destroy.owl.carousel');

    // This listener has to be added before the initialization of the plugin
    projectPhotos.on('initialized.owl.carousel', (event) => {
      if ($(window).width() > 768 && event.item.count <= 2) {
        $('.carousel-controls .next').addClass('disabled');
      }

      if ($(window).width() < 768 && event.item.count === 1) {
        $('.carousel-controls .next').addClass('disabled');
      }
    });
    
    projectPhotos.owlCarousel({
      items: 1,
      dots: false,
      responsive: {
        768: {
          items: 2,
          margin: 25,
        },
      },
    });

    projectPhotos.on('changed.owl.carousel', (event) => {
      $('.carousel-controls .prev').toggleClass('disabled', event.item.index === 0);
      $('.carousel-controls .next').toggleClass('disabled', event.item.index === event.item.count - event.page.size);
    });

  
    $('.carousel-controls .prev').on('click', () => projectPhotos.trigger('prev.owl.carousel'));
    $('.carousel-controls .next').on('click', () => projectPhotos.trigger('next.owl.carousel'));

    let searchTimeout = null;
    $('.office-locator-input').on('keyup', () => {
      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(() => {
        Infrasupport.officeLocatorHandler();
      }, 500);
    });


    $('.product-gallery .thumbnail-wrap').on('click', event => Infrasupport.enlargeImage(event));
  }

  static officeLocatorHandler() {
    const input = $('.office-locator-input').val();

    if (input && input.length) {
      $('.office-locator-loader').show();

      Infrasupport.getZipCode(input)
        .then((zipcode) => {
          Infrasupport.updateLocation(zipcode);
        })
        .catch(() => {
          $('.office-locator-loader').hide();
          $('.office-title-wrap').hide();

          $('.office-locator-address').html(`
            <div class="error">Er was een probleem met de invoer, controleer het veld hierboven op typefouten</div>
          `);
        });
    }
  }

  static updateLocation(zipcode) {
    $('.office-locator-loader').hide();

    const location = Infrasupport.getBUKOLocation(zipcode.substr(0, 4));

    // Translate location title
    const lang = document.documentElement.getAttribute('lang');

    if (lang === 'de-DE') {
      location.title = location.title.replace('Regiovestiging', 'Filiale');
    }

    if (lang === 'en-US') {
      location.title = location.title.replace('Regiovestiging', 'Branch');
    }

    if (lang !== 'nl-NL') {
      location.phone = `+31 ${location.phone}`;
    }

    // Update the front-end fields
    if (location) {
      $('.office-locator-address').html(`
        ${location.street} ${location.number}<br>
        ${location.zipcode} ${location.city}<br>
        ${location.phone}<br>
        <a href="mailto:${location.mail}">${location.mail}</a>
      `);

      $('.office-title-wrap .office-title').html(location.title);
      $('.office-title-wrap').show();
    } else {
      $('.office-locator-address').html('Er is geen overeenkomende locatie gevonden.');
    }
  }

  /**
   * The Geocoding API won't return a zipcode with a city name alone, that's too broad
   * To combat this we pass the city name, retrieve the latlng data and PASS that value
   * to the Geocoding API. That location data is specific enough to get the zipcode.
   * 
   * @param {string} input 
   */
  static getZipCode(input) {
    return new Promise((resolve, reject) => {
      if (Infrasupport.isValidZipCode(input)) {
        resolve(input);
      }
      
      const moreCompleteAddress = `${input}, Nederland`;

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        address: moreCompleteAddress,
      }, (results1, status1) => {
        if (status1 === google.maps.GeocoderStatus.OK) {
          const latitude = results1[0].geometry.location.lat();
          const longitude = results1[0].geometry.location.lng();

          // Here we go again!
          geocoder.geocode({
            location: new google.maps.LatLng(latitude, longitude),
          }, (results2, status2) => {
            if (status2 === google.maps.GeocoderStatus.OK) {
              
              for (let i = 0; i < results2.length; i++) {
                var zipcodeObject = results2[i].address_components.find(address => address.types[0] === 'postal_code');

                if (zipcodeObject !== undefined) {
                  resolve(zipcodeObject.long_name);
                }
              }
              
              reject(new Error('Could not resolve postalcode by name of this location'));

            } else {
              reject(new Error('Geocoding failed in second lookup'));
            }
          });
        } else {
          reject(new Error('Geocoding failed'));
        }
      });
    });
  }

  static isValidZipCode(zipcode) {
    const regex = /^[1-9][0-9]{3} ?([a-zA-Z]{2})?$/;

    return regex.test(zipcode.trim());
  }

  static getBUKOLocation(zipcode) {
    return Locations.location.find(location => location.matchingZipcodes.includes(zipcode));
  }

  static enlargeImage(event) {
    const thumbnail = $(event.currentTarget);
    const largeSrc = thumbnail.data('large');
    const largeImage = $('.product-gallery .large-image img');

    largeImage.attr('src', largeSrc);
    $('.product-gallery .thumbnail-wrap.active').removeClass('active');
    thumbnail.addClass('active');
  }
  
  removeLoadingOverlay() {
    this.loadingOverlay[0].addEventListener('transitionend', () => {
      this.loadingOverlay.hide();
    });
  }
}

$(document).ready(() => {
  Infrasupport.init();
});
